var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.$vuetify.breakpoint.xsOnly ? _vm.DialogScrollLock : _vm.MenuScrollLock, _vm._b({
    tag: "component",
    attrs: {
      "eager": "",
      "content-class": `nav-menu-content prominent ${_vm.isLoaded ? '' : 'loading'}`,
      "value": _vm.value && _vm.isLoaded
    },
    on: {
      "input": function (v) {
        return _vm.value = v;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs;
        return [_vm.header ? _c('v-btn', _vm._b({
          staticClass: "header-menu font-weight-bold my-3 mx-1 px-2",
          attrs: {
            "text": "",
            "rounded": "",
            "color": "ec-dark-blue",
            "disabled": _vm.disabled,
            "loading": _vm.value && !_vm.isLoaded,
            "input-value": _vm.value
          },
          on: {
            "click": function ($event) {
              _vm.value = true;
            }
          }
        }, 'v-btn', attrs, false), [_vm._v(" " + _vm._s(_vm.name) + " "), _c('v-icon', {
          staticClass: "mr-n1",
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMenuDown)
          }
        })], 1) : _c('v-list-item', _vm._b({
          class: (_vm.disabled ? 'grey' : 'ec-dark-blue') + '--text header-menu',
          attrs: {
            "disabled": _vm.disabled,
            "input-value": _vm.value
          },
          on: {
            "click": function ($event) {
              _vm.value = true;
            }
          }
        }, 'v-list-item', attrs, false), [_c('div', {
          staticClass: "relative"
        }, [_c('v-icon', {
          staticClass: "header-menu-left hidden-xs-only",
          staticStyle: {
            "position": "absolute",
            "top": "6px",
            "left": "-14px"
          },
          attrs: {
            "small": "",
            "color": "ec-dark-blue"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronLeft)
          }
        }), _c('v-icon', {
          attrs: {
            "color": _vm.disabled ? 'grey' : 'ec-dark-blue'
          },
          domProps: {
            "innerHTML": _vm._s(_vm.icon)
          }
        })], 1), _c('v-list-item-title', {
          staticClass: "ml-3 text-body-2",
          domProps: {
            "innerHTML": _vm._s(_vm.name)
          }
        }), _vm.value && !_vm.isLoaded ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "ec-dark-blue",
            "size": "20",
            "width": "2"
          }
        }) : _vm._e()], 1)];
      }
    }])
  }, 'component', _vm.$vuetify.breakpoint.xsOnly ? {} : {
    'max-width': '960px',
    bottom: _vm.header,
    'offset-y': _vm.header,
    left: !_vm.header,
    'offset-x': !_vm.header,
    'nudge-right': _vm.header ? 0 : 1
  }, false), [_c('div', {
    staticClass: "constrain",
    class: {
      header: _vm.header
    }
  }, [_vm.$vuetify.breakpoint.xsOnly ? [_c('div', {
    staticClass: "pa-3 d-flex align-center font-weight-bold"
  }, [_c('div', {
    staticClass: "flex-grow-1 ec-dark-blue--text"
  }, [_vm._v(_vm._s(_vm.name))]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "!click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.value = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1)], 1), _c('v-divider')] : _vm._e(), _vm._t("default")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }